import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, ErrorComponent } from '@tanstack/react-router'
import { membershipQueryOptions } from '../../api/membershipQueryOptions'

import { Grid } from '@mui/material'

import { MembershipType } from '@/api/memberships'
import LoadProgress from '@/components/LoadProgress'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@mui/material'
import { useForm } from 'react-hook-form'

import { NoPermissionError } from '@/api/NoPermissionError'
import { membershipSchema } from '@/api/mem/memberMembership'
import { useUpdateMembershipMutation } from '@/api/mem/memberMembershipQueryOptions'
import FormDebug from '@/components/FormDebug'
import { NoPermissionErrorComponent } from '@/components/NoPermissionErrorComponent'
import MembershipForm from '@/components/form/MembershipForm'
import { DevTool } from '@hookform/devtools'
import { enqueueSnackbar } from 'notistack'

export const Route = createFileRoute(
    '/_auth/membership_/$membershipUuid/main'
)({
    component: MembershipComponent,
    errorComponent: ({ error }) => {
        if (error instanceof NoPermissionError) {
            return (
                <NoPermissionErrorComponent error={error}></NoPermissionErrorComponent>
            )
        }
        return <ErrorComponent error={error}></ErrorComponent>
    },
})

function MembershipComponent() {
    const params = Route.useParams()
    const membershipQuery = useSuspenseQuery(
        membershipQueryOptions(params.membershipUuid),
    )
    const membership = membershipQuery.data

    const updateMembershipMutation = useUpdateMembershipMutation(
        membership.member.uuid,
        () => { },
        () => { },
    )

    const {
        control,
        register,
        handleSubmit,
        formState: { isDirty, isValid, errors },
    } = useForm<MembershipType>({
        resolver: yupResolver<MembershipType, any, any>(membershipSchema),
        mode: 'onChange',
        shouldFocusError: true,
    })

    const onSubmit = (data: MembershipType) => {
        if (isValid) {
            updateMembershipMutation.mutate({ ...membership, ...data })
            enqueueSnackbar('Mitgliedschaft geändert')
        } else {
            console.log(errors)
        }
    }

    if (membershipQuery.isLoading || membershipQuery.isFetching || !membership) {
        return <LoadProgress />
    }

    const writeable = membership.permissions
        ? membership.permissions.some((perm) => perm === 'write')
        : false

    return (<>
        <form onSubmit={handleSubmit(onSubmit)}>
            <MembershipForm
                control={control}
                register={register}
                membership={membership}
                writeable={writeable}
            />
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                    }}>
                    <Button
                        type="submit"
                        variant="outlined"
                        disabled={!isDirty || !isValid || !writeable}
                    >
                        Speichern
                    </Button>
                </Grid>
            </Grid>
        </form>
        <FormDebug
            errors={errors}
            dirty={isDirty}
            valid={isValid}
            value={membership}
        />
        {import.meta.env.VITE_DEBUG === 'true' &&
            <DevTool control={control} />
        }
    </>);
}
